/**
 * 文档类型.
 * - [后台协议](https://git.woa.com/docx-online/docx-online/blob/167d4623/backend/common/proto/3rd/oidb/docs/online_docs_comm.proto#L13)
 */
export var DocType = /*#__PURE__*/function (DocType) {
  DocType[DocType["Doc"] = 0] = "Doc";
  DocType[DocType["Sheet"] = 1] = "Sheet";
  DocType[DocType["Form"] = 2] = "Form";
  DocType[DocType["Folder"] = 3] = "Folder";
  DocType[DocType["Slide"] = 4] = "Slide";
  DocType[DocType["Note"] = 5] = "Note";
  DocType[DocType["Pdf"] = 6] = "Pdf";
  DocType[DocType["MiniProgram"] = 7] = "MiniProgram";
  DocType[DocType["Aio"] = 7] = "Aio";
  DocType[DocType["SmartCanvas"] = 8] = "SmartCanvas";
  DocType[DocType["SmartSheet"] = 9] = "SmartSheet";
  DocType[DocType["Unknown"] = 10] = "Unknown";
  DocType[DocType["Resume"] = 11] = "Resume";
  DocType[DocType["Board"] = 12] = "Board";
  DocType[DocType["Ofd"] = 13] = "Ofd";
  DocType[DocType["Markdown"] = 14] = "Markdown";
  DocType[DocType["Drawing"] = 89] = "Drawing";
  DocType[DocType["Mind"] = 90] = "Mind";
  DocType[DocType["FlowChart"] = 91] = "FlowChart";
  DocType[DocType["Flowchart"] = 91] = "Flowchart";
  DocType[DocType["File"] = 100] = "File";
  DocType[DocType["Drive"] = 101] = "Drive";
  DocType[DocType["Rec"] = 102] = "Rec";
  DocType[DocType["Addon"] = 110] = "Addon";
  DocType[DocType["LocalFile"] = -201] = "LocalFile";
  return DocType;
}({});
//# sourceMappingURL=doc-type.js.map